import { getPriceParts } from "./formatPrice";
import styles from "./stylizedPrice.module.scss";

/**
 * "$261⁹⁹": the dollar sign and cents sit raised beside the whole dollars. Hidden from screen readers, so pair it
 * with the price as text.
 */
export default function StylizedPrice({ price, size }: StylizedPriceProps) {
  const { dollars, cents } = getPriceParts(price);

  return (
    <span className={`${styles.StylizedPrice} ${styles[size]}`} aria-hidden>
      <span className={styles.currencySymbol}>$</span>
      <span className={styles.dollars}>{dollars}</span>
      <span className={styles.cents}>{cents}</span>
    </span>
  );
}

interface StylizedPriceProps {
  price: number;
  size: "sm" | "md" | "lg" | "xl";
}
